module.exports = __webpack_public_path__ + "img/restaurant_bodyimage06.7809df94.jpg";